import { BadgePosition } from './types'

export const DefaultMenuTheme = {
  descriptionBgColor: '#a0a0a0',
  descriptionFontColor: '#191919',
  descriptionFontSize: 16,
  descriptionMargin: 16,

  legendFontSize: 12,
  legendFontColor: '#191919',
  legendFontWeight: 'bold',
  legendSpacing: 14,

  itemFontSize: 14,
  itemVerticalMargin: 10,
  itemHorizontalMargin: 16,
  itemBgColor: '#f2f2f2',
  itemFontColor: '#424242',
  itemGlyphColor: '#424242',
  separatorColor: '#e0e0e0',
  width: 250,

  bottomBarColor: '#e0e0e0',
  className: undefined
}

export const DefaultMenuProps = {
  description: 'Hello My Menu World!',
  legend: 'Legend goes here:',
  items: []
}

export const DefaultHintTheme = {
  bgColor: '#424242',
  className: undefined,
  fontColor: 'white',
  fontSize: '16px',
  margin: 8,
  hintContents: '',
  width: 230
}

export const DefaultBadgeProps = {
  bgColor: '#888',
  className: undefined,
  fontColor: '#FFF',
  height: 48,
  loading: false,
  margin: 8,
  menuEnabled: true,
  menuTheme: DefaultMenuTheme,
  hintTheme: DefaultHintTheme,
  menu: DefaultMenuProps,
  position: BadgePosition.BottomRight,
  showProgress: true,
  progress: 0
}
